import { jsxs as i, jsx as e } from "@emotion/react/jsx-runtime";
import { Stack as h, Text as d } from "@partoohub/ui";
import { GroupButtonContainer as m, StyledFilterButtonText as u, RedDot as f } from "./GroupButton.styled.js";
import { ConditionalResetIcon as y } from "../../ConditionalResetIcon/ConditionalResetIcon.js";
const b = ({
  dataTrackId: n,
  buttonText: r,
  numberOfGroupsSelected: t = 0,
  disabled: a = !1,
  onClick: c,
  onReset: s
}) => {
  const o = t > 0, l = t > 99 ? "99+" : t;
  return /* @__PURE__ */ i(m, { dataTrackId: n, onClick: c, disabled: a, variant: "secondary", shape: "cube", size: "large", appearance: "outlined", children: [
    /* @__PURE__ */ i(h, { direction: "row", gap: "24px", justifyContent: "space-between", alignItems: "center", children: [
      r && /* @__PURE__ */ e(u, { variant: "bodyMSemibold", as: "span", color: o ? "default" : "secondary", children: r }),
      /* @__PURE__ */ e(y, { dataTrackId: n, applyDefaultColor: o, showReset: !!(s && o), onReset: (p) => {
        p.stopPropagation(), a || s?.();
      } })
    ] }),
    o && /* @__PURE__ */ e(f, { children: /* @__PURE__ */ e(d, { variant: "bodyXSSemibold", as: "span", color: "white", children: l.toString() }) })
  ] });
};
export {
  b as GroupButton
};
